import { Grid, TextField, Button } from "@material-ui/core"
import * as yup from "yup";
import { useFormik } from "formik";
import { useState, useEffect } from "react";
import BackDrop from "../../../global/BackDrop";
import { phoneRegExp } from "../../../utils/yupCustomShema";
import { useSelector, useDispatch } from "react-redux";
import { DialogMessage } from "../../../global/DialogMessage";
import { ToastMessage } from "../../../global/ToastMessage";
import { selectClienteTarget, actulizarDatosContactoAction } from "../../../ducks/clientesDuck";
import { esFinalizado } from "../../../utils/esFinalizado";
const validationSchema = yup.object({
    nombre: yup.string("Ingresa un nombre").required("Nombre es requerido"),
    apellidop: yup
        .string("Ingresa un apellido paterno")
        .optional(),
    apellidom: yup.string("Ingresa un apellido materno").optional(),
    telefono: yup
        .string("Ingresa un telefono")
        .matches(phoneRegExp, "Numero de telefono invalido")
        .required("Telefono es requerido"),
    correo: yup
        .string("Ingresa un email")
        .email("Email invalido")
        .required("Email es requerido"),
})
const InitalValues = {
    nombre: "",
    apellidop: "",
    apellidom: "",
    telefono: "",
    correo: ""
}
const ArrayFormValues = [
    {
        name: "nombre",
        type: "text",
        label: "Nombre"
    },
    // {
    //     name: "apellidop",
    //     type: "text",
    //     label: "Apellido paterno"
    // },
    // {
    //     name: "apellidom",
    //     type: "text",
    //     label: "Apellido materno"
    // },
    {
        name: "telefono",
        type: "text",
        label: "Telefono"
    },
    {
        name: "correo",
        type: "text",
        label: "Correo"
    },
]
const FielEdit = (props) => {
    const {
        name,
        label,
        type = "text",
        verificado,
        formik,
    } = props
    const [editar, setEditar] = useState(false)
    const hangdleClickEditar = () => {
        setEditar(!editar)
    }
    return (
        <div style={{ margin: "0.5rem 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <TextField
                required
                disabled={verificado || !editar}
                style={{ width: "100%" }}
                id={`id-${name}`}
                label={label}
                type={type}
                variant="outlined"
                name={name}
                value={formik.values[name]}
                onChange={formik.handleChange}
                error={formik.touched[name] && Boolean(formik.errors[name])}
                helperText={formik.touched[name] && formik.errors[name]}
            />
            {
                (!editar) &&
                <Button
                    style={{ margin: "0 2%" }}
                    variant="contained"
                    color="primary"
                    disabled={verificado}
                    onClick={hangdleClickEditar}
                >
                    Editar
                </Button>
            }
            {
                (editar) &&
                <div style={{ margin: "0 2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Button
                        style={{ margin: "0 2%" }}
                        variant="contained"
                        color="primary"
                        disabled={verificado}
                        type="submit"
                    >
                        Guardar
                    </Button>
                    <Button
                        style={{ margin: "0 2%" }}
                        variant="contained"
                        color="default"
                        disabled={verificado}
                        onClick={hangdleClickEditar}
                    >
                        Cancelar
                    </Button>
                </div>
            }
        </div>
    )
}
const FCliente = () => {
    const { cliente, referencia, verificado } = useSelector(store => store.cliente)
    const [load, setLoad] = useState(false)
    const dispatch = useDispatch()
    const formik = useFormik({
        initialValues: InitalValues,
        validationSchema: validationSchema,
        onSubmit: (values) => handleSubmit(values),
    });
    const handleSubmit = (values) => {
        if (verificado)
            return null
        DialogMessage.fire({
            title: `Actulizacion de datos`,
            text: `¿Esta seguro de que la información del cliente es la correcta?`,
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                let payload = {
                    ...values,
                    Referencia: referencia,
                    apellidoP: values.apellidop,
                    apellidoM: values.apellidom,
                }
                setLoad(true)
                dispatch(actulizarDatosContactoAction(payload)).then(Response => {
                    if (Response?.status && Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    dispatch(selectClienteTarget({ cliente, referencia }))
                    setLoad(false)
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
    }

    useEffect(() => {
        formik.setFieldValue("nombre", cliente?.Titular)
        // formik.setFieldValue("apellidop", cliente?.Movimiento?.Cuenta?.Apellido_Paterno)
        // formik.setFieldValue("apellidom", cliente?.Movimiento?.Cuenta?.Apellido_Materno)
        formik.setFieldValue("apellidop", "")
        formik.setFieldValue("apellidom", "")
        formik.setFieldValue("telefono", cliente?.Movimiento?.Cuenta?.Telefono_Contacto)
        formik.setFieldValue("correo", cliente?.Movimiento?.Cuenta?.eMail)
    }, [cliente.idCotizacion]) //eslint-disable-line

    return (
        <div>
            <form onSubmit={formik.handleSubmit}>
                <Grid container>
                    {
                        ArrayFormValues.map((item, index) =>
                            <Grid item xs={12} key={item.name}>
                                <FielEdit
                                    name={item.name}
                                    label={item.label}
                                    type={item.type}
                                    verificado={verificado || esFinalizado(cliente?.paquete?.CatEstatusProceso?.IdEstatusProceso)}
                                    formik={formik}
                                />
                            </Grid>        
                        )
                    }
                </Grid>
                <BackDrop open={load} />
            </form>
        </div>
    )
}
export default FCliente